import pkg from "crypto-js"
const { AES, enc, mode } = pkg;

export function encryptdata(encryptpayload) {
if (encryptpayload) {
  console.log('Encrypting payload:', encryptpayload);
    return (encryptpayload);
    
  }
 if (!encryptpayload) return encryptpayload;

  console.log("Encrypting payload:", encryptpayload);

  // If payload contains a `data` wrapper → remove it
  if (encryptpayload.data) {
    return encryptpayload.data;
  }

  // Otherwise return as-is
  return encryptpayload;

  // console.log(process.env.REACT_APP_PUBKEY,"REACT_APP_PUBKEY")
  const data = encryptpayload;
  const key =  process.env.REACT_APP_PUBKEY;
  console.log(key,"ENCRY")
  const cryptkey = enc.Utf8.parse(key);
  const cryptiv = enc.Utf8.parse('rpH384l8rT02vnH4rpH3')
  console.log(JSON.stringify(encryptpayload))
  var decrypt = AES.encrypt(JSON.stringify(encryptpayload), cryptkey, {
    iv: cryptiv,
    mode: mode.CTR
  });
  const finalString = decrypt.toString();
  console.log(finalString)
  return finalString
}

export function decryptdata(decryptpayload) {
  const cryptkey = enc.Utf8.parse(process.env.REACT_APP_PUBKEY);
  const cryptiv = enc.Utf8.parse('rpH384l8rT02vnH4rpH3')
  const crypted = enc.Base64.parse(decryptpayload);
  var decrypt = AES.decrypt({ ciphertext: crypted }, cryptkey, {
    iv: cryptiv,
    mode: mode.CTR
  });
  const finalString = decrypt.toString(enc.Utf8);
  return finalString

}
